import { c as _c } from "react/compiler-runtime";
import RenderImage from "@/components/atoms/RenderImage";
import useRealEstateDetail from "@/hooks/QueryHooks/useRealEstateDetail";
import { getPriceDisplay } from "@/lib/price";
type Props = {
  slug: string;
  originalPrice: number;
  selectedItem: boolean;
};
export default function CompareItem(t0) {
  const $ = _c(27);
  const {
    slug,
    originalPrice,
    selectedItem
  } = t0;
  let t1;
  if ($[0] !== slug) {
    t1 = {
      realEstateSlug: slug
    };
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const realEstateDetail = useRealEstateDetail(t1);
  const t2 = realEstateDetail.data?.data.realEstate.businessType;
  const t3 = realEstateDetail.data?.data.realEstate.salePrice;
  const t4 = realEstateDetail.data?.data.realEstate.lastBidPrice;
  const t5 = realEstateDetail.data?.data.realEstate.minPrice;
  let t6;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = getPriceDisplay({
      businessType: t2,
      salePrice: t3,
      lastBidPrice: t4,
      minPrice: t5
    });
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const currentPrice = t6.value;
  const priceDifference = currentPrice - originalPrice;
  const isLower = priceDifference < 0;
  const absoluteDifference = Math.abs(priceDifference);
  let t7;
  if ($[7] !== absoluteDifference || $[8] !== originalPrice) {
    t7 = originalPrice > 0 ? Math.round(absoluteDifference / originalPrice * 100) : 0;
    $[7] = absoluteDifference;
    $[8] = originalPrice;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const percentageDiff = t7;
  if (!realEstateDetail.data || !realEstateDetail) {
    return null;
  }
  const t8 = selectedItem ? "hsl(var(--chart-5))" : "transparent";
  let t9;
  if ($[10] !== t8) {
    t9 = {
      transition: "border-color 0.3s ease",
      borderColor: t8,
      borderWidth: 3,
      borderStyle: "solid"
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = realEstateDetail?.data?.data.realEstate.thumbnails?.[0];
  let t11;
  if ($[12] !== t10) {
    t11 = <RenderImage alt="" src={t10} className="w-full h-full rounded-lg object-cover" data-sentry-element="RenderImage" data-sentry-source-file="CompareItem.tsx" />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = `absolute top-2 right-2 px-2 py-1 rounded text-white text-xs font-medium ${isLower ? "bg-green-500" : "bg-red-500"}`;
  const t13 = isLower ? "-" : "+";
  let t14;
  if ($[14] !== percentageDiff || $[15] !== t12 || $[16] !== t13) {
    t14 = <div className={t12}>{t13}{percentageDiff}%</div>;
    $[14] = percentageDiff;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t11 || $[19] !== t14 || $[20] !== t9) {
    t15 = <div className="relative aspect-square w-full rounded-xl cursor-pointer flex flex-col" style={t9}>{t11}{t14}</div>;
    $[18] = t11;
    $[19] = t14;
    $[20] = t9;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = realEstateDetail?.data.data.realEstate.title;
  let t17;
  if ($[22] !== t16) {
    t17 = <div className="w-full mt-1"><span className="text-foreground-heading text-sm block w-full overflow-hidden text-ellipsis whitespace-nowrap">{t16}</span></div>;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t15 || $[25] !== t17) {
    t18 = <div className="w-full" data-sentry-component="CompareItem" data-sentry-source-file="CompareItem.tsx">{t15}{t17}</div>;
    $[24] = t15;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  return t18;
}